import React from 'react';
import loader from '@assets/gif/loader.gif';
import styles from './styles.module.css';

type LoaderProps = {
  testId?: string;
};

export const Loader: React.FC<LoaderProps> = ({ testId = 'loader' }) => {
  return (
    <div className={styles.loader} data-testid={testId}>
      <img
        className="h-14 w-14 mt-5"
        src={loader}
        alt="Loading..."
        data-testid={`${testId}-image`}
      />
      <span className="text-interfaceColor-90" data-testid={`${testId}-text`}>
        Loading
      </span>
    </div>
  );
};
